{
  "jsm-live-chat-helpseeker-spotlight.body": [
    {
      "type": 0,
      "value": "You can connect to a agent from this widget. Start the Live Chat then ask AI to speak to an agent."
    }
  ],
  "jsm-live-chat-helpseeker-spotlight.connect-link": [
    {
      "type": 0,
      "value": "Chat to a human now"
    }
  ],
  "jsm-live-chat-helpseeker-spotlight.title": [
    {
      "type": 0,
      "value": "Human support is available"
    }
  ]
}